import { TemplateWithTimesplit } from '~/interfaces/TemplateWithTimesplit';
import SmallSchedule from '../showSchedule/SmallSchedule';
import { timesplitIcons } from '~/routes/schedule.templates';
import Tags from './Tags';
import TimesplitPill from './TimesplitPill';

interface Props {
  onSelect: () => void;
  template: TemplateWithTimesplit;
}

export default function TemplateTypeCard({ onSelect, template }: Props) {
  return (
    <div className="flex w-full flex-col justify-center rounded-2xl border-2 border-taupe bg-beige-light-20 p-4 px-4 py-4">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex flex-wrap items-center justify-start gap-x-2 gap-y-1">
          <span className="flex items-center justify-start gap-x-2 text-xl font-medium text-green-primary-text">
            {timesplitIcons[template.timesplitName.replace('-', '/')]}
            {template.name}
          </span>
          <TimesplitPill timesplit={template.timesplitName} />
        </div>

        <button
          onClick={onSelect}
          className="rounded-full border border-green-dark-2 bg-green-dark-2 px-3 py-[7px] text-xs font-bold uppercase text-neutral-offWhite"
          type="button"
        >
          Select
        </button>
      </div>
      <div className="w-full border-b border-dashed border-taupe" />
      <SmallSchedule days={template.days} />
      <div className="w-full border-b border-dashed border-taupe" />
      <Tags template={template} />
    </div>
  );
}
